import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import theme from './index';
export default (function (el) { return (React.createElement(ThemeProvider, { theme: theme }, el)); });
//# sourceMappingURL=themeDecorator.js.map